import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "back",
  "use": "back-usage",
  "viewBox": "0 0 15.4 26.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.4 26.3\" id=\"back\"><path fill=\"none\" stroke-width=\"3\" stroke-miterlimit=\"10\" d=\"M14.3 25.3L2.1 13.2 14.3 1.1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol